// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activity-report-filter {
  width: 100%;
}
.activity-report-filter .right-align {
  display: block;
  float: right;
  position: relative;
}
.activity-report-filter .left-margin {
  margin-left: 5px;
}
.activity-report-filter .label {
  font-weight: bold;
}
.activity-report-filter .left-align {
  display: block;
  float: left;
}
.activity-report-filter .ui-button {
  padding: 2px 0px !important;
}
.activity-report-filter .row {
  display: flex;
  margin-bottom: 15px;
}
.activity-report-filter .margin {
  float: right;
  margin-right: 10px;
}
.activity-report-filter .gap {
  margin-right: 15px; /* Adjust this value as needed */
}
.activity-report-filter :host ::ng-deep .custom-save-button {
  background: #0066B2 !important; /* Primary blue background */
  color: #ffffff !important; /* White text */
  border: none !important; /* Remove border */
  border-radius: 4px !important; /* Rounded corners */
  padding: 8px 16px !important; /* Add padding */
  font-family: "GothamBold", "Helvetica Neue", "Helvetica", "Arial", "sans-serif" !important; /* Font family */
  font-size: 14px !important; /* Font size */
  cursor: pointer !important; /* Pointer cursor */
  transition: background-color 0.3s ease, transform 0.2s ease !important; /* Smooth hover and transform effects */
}
.activity-report-filter :host ::ng-deep .custom-save-button:hover {
  background: #0B2D71 !important; /* Darker blue on hover */
  color: #ffffff !important; /* Ensure white text on hover */
  transform: translateY(-2px) !important; /* Slight lift effect on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important; /* Add shadow on hover */
}
.activity-report-filter :host ::ng-deep .custom-save-button:disabled {
  background: #d6d8db !important; /* Gray background for disabled state */
  color: #6c757d !important; /* Muted text color */
  cursor: not-allowed !important; /* Disabled cursor */
  box-shadow: none !important; /* Remove shadow for disabled state */
}`, "",{"version":3,"sources":["webpack://./src/components/activity-report-filters/activity-report-filters.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAAE;EACE,cAAA;EACA,YAAA;EACA,kBAAA;AAEJ;AAAE;EACE,gBAAA;AAEJ;AAAE;EACE,iBAAA;AAEJ;AAAE;EACE,cAAA;EACA,WAAA;AAEJ;AAAE;EACE,2BAAA;AAEJ;AAAE;EACE,aAAA;EACA,mBAAA;AAEJ;AACE;EACE,YAAA;EACA,kBAAA;AACJ;AACE;EAAO,kBAAA,EAAA,gCAAA;AAET;AAAE;EACA,8BAAA,EAAA,4BAAA;EACA,yBAAA,EAAA,eAAA;EACA,uBAAA,EAAA,kBAAA;EACA,6BAAA,EAAA,oBAAA;EACA,4BAAA,EAAA,gBAAA;EACA,0FAAA,EAAA,gBAAA;EACA,0BAAA,EAAA,cAAA;EACA,0BAAA,EAAA,mBAAA;EACA,sEAAA,EAAA,uCAAA;AAEF;AACA;EACE,8BAAA,EAAA,yBAAA;EACA,yBAAA,EAAA,+BAAA;EACA,sCAAA,EAAA,gCAAA;EACA,mDAAA,EAAA,wBAAA;AACF;AAEA;EACE,8BAAA,EAAA,uCAAA;EACA,yBAAA,EAAA,qBAAA;EACA,8BAAA,EAAA,oBAAA;EACA,2BAAA,EAAA,qCAAA;AAAF","sourcesContent":[".activity-report-filter {\n  width: 100%;\n  .right-align {\n    display: block;\n    float: right;\n    position: relative;\n  }\n  .left-margin {\n    margin-left: 5px;\n  }\n  .label {\n    font-weight: bold;\n  }\n  .left-align {\n    display: block;\n    float: left;\n  }\n  .ui-button {\n    padding: 2px 0px !important;\n  }\n  .row {\n    display: flex;\n    margin-bottom: 15px;\n    \n  }\n  .margin{\n    float: right;\n    margin-right: 10px;\n  }\n  .gap { margin-right: 15px; /* Adjust this value as needed */ }\n\n  :host ::ng-deep .custom-save-button {\n  background: #0066B2 !important; /* Primary blue background */\n  color: #ffffff !important; /* White text */\n  border: none !important; /* Remove border */\n  border-radius: 4px !important; /* Rounded corners */\n  padding: 8px 16px !important; /* Add padding */\n  font-family: 'GothamBold', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif' !important; /* Font family */\n  font-size: 14px !important; /* Font size */\n  cursor: pointer !important; /* Pointer cursor */\n  transition: background-color 0.3s ease, transform 0.2s ease !important; /* Smooth hover and transform effects */\n}\n\n:host ::ng-deep .custom-save-button:hover {\n  background: #0B2D71 !important; /* Darker blue on hover */\n  color: #ffffff !important; /* Ensure white text on hover */\n  transform: translateY(-2px) !important; /* Slight lift effect on hover */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important; /* Add shadow on hover */\n}\n\n:host ::ng-deep .custom-save-button:disabled {\n  background: #d6d8db !important; /* Gray background for disabled state */\n  color: #6c757d !important; /* Muted text color */\n  cursor: not-allowed !important; /* Disabled cursor */\n  box-shadow: none !important; /* Remove shadow for disabled state */\n}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
